import {useTranslation} from "react-i18next";
import {useMedia} from "@hooks/ui/useMedia";

import moment from 'moment'
import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import React from 'react'

const SelectMonths = ({onChange, currentMonth, size = 'small'}) => {

    const {t} = useTranslation()
    const{isDesktop} = useMedia()

    const allMonths = React.useMemo(() => {
       const data = isDesktop ? moment().creationData().locale.monthsShort() : moment().creationData().locale.months();

        return data.map((item)=>{
            return {
                label:item,
                value:item
            }
        })
    }, [moment])

    if (!allMonths) {
        return <></>
    }

    return (
        <SelectCustom
            label={t('month')}
            size={size}
            value={allMonths[currentMonth]?.value}
            onChange={onChange}
            data={allMonths}
        />
    )
}
export default SelectMonths